import React, { useState, useCallback, useImperativeHandle } from 'react';
import {
  Button,
  Row,
  Col,
  Image as ImageBS,
  Form,
  Popover,
  OverlayTrigger,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { adminActions, alertActions } from '../../redux/_actions';
import {
  genderType,
  leagueType,
  imgType,
  FILE_SIZE,
} from '../../redux/_constants';
import * as Yup from 'yup';

export const TeamCoaches = React.forwardRef((props, ref) => {
  const { teamId, isEditing, isSaving, reset, setIsLoading } = props;
  const { teams } = useSelector((state) => state.admin);
  const team = teams.byId[teamId];

  const emptyList = () => {
    return (
      <Row
        style={{ minHeight: '40vh', textAlign: 'center' }}
        className="vCenter"
      >
        <span>No coaches assigned.</span>
      </Row>
    );
  };

  const setupBody = () => {
    if (team.coaches.items.length === 0) {
      return emptyList();
    } else {
      return null;
    }
  };

  return (
    <Form onSubmit={null} className="teamCoaches">
      {setupBody()}
    </Form>
  );
});
